import { actionTypes } from '../actioncreators/actioncreators'
import { hosts } from '../actioncreators/hosts'

let initialState = {
  saveCounter: 0,
  host: hosts.STANDALONE,
  displayExportDialogue: false
}

export const GeneralReducer = (currentState = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_HOST:
      return Object.assign({}, currentState, { host: action.value })
    case actionTypes.INCREMENT_SAVE_COUNTER:
      return Object.assign({}, currentState, { saveCounter: currentState.saveCounter + 1 })
    case actionTypes.DECREMENT_SAVE_COUNTER:
      return Object.assign({}, currentState, { saveCounter: currentState.saveCounter - 1 })
    case actionTypes.CLOSE_EXPORT_DIALOGUE:
      return Object.assign({}, currentState, { displayExportDialogue: false })
    case actionTypes.OPEN_EXPORT_DIALOGUE:
      return Object.assign({}, currentState, { displayExportDialogue: true })
    default:
      return currentState
  }
}

export default GeneralReducer
